import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Logo from "../assets/logo.png";
import { RUTA_IMG } from "../componentes/config.js";
import { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { sql } from "../componentes/api.js";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import { DocumentViewer } from "react-documents";

function VerAnexosLista(props) {
  const [datos, setDatos] = useState([]);
  const [mostrarAnexos, setMostrarAnexos] = useState(false);
  const [verReproductor, setVerReproductor] = useState(false);
  const [verImagen, setVerImagen] = useState(false);
  const [verDocumento, setVerDocumento] = useState(false);
  const [verAudio, setVerAudio] = useState(false);
  const [ruta, setRuta] = useState("");
  const [msg, setMsg] = useState("No se han encontrado archivos anexos!");
  const tab = <>&nbsp;&nbsp;&nbsp;&nbsp;</>;

  useEffect(() => {
    const consultar = async () => {
      try {
        if (props.idProyectoActividad !== undefined) {
          if (props.idParticipante !== undefined) {
            const response = await sql(
              "getProyectoActividadDesarrolloAnexos",
              "POST",
              {
                idProyectoActividad: props.idProyectoActividad,
                idProyectoActividadDesarrollo:
                  props.idProyectoActividadDesarrollo,
              }
            );
            console.log("Longitud " + response.length);
            if (response.length > 0) {
              setDatos(response);
              setMsg(
                "Presione sobre un botón para ver el contenido del archivo anexo!"
              );
              setMostrarAnexos(true);
            } else {
              setMsg("No se han encontrado archivos anexos!");
            }
          } else {
            const response = await sql("getProyectoActividadAnexos", "POST", {
              idProyectoActividad: props.idProyectoActividad,
            });
            console.log("Longitud " + response.length);
            if (response.length > 0) {
              setDatos(response);
              setMsg(
                "Presione sobre un botón para ver el contenido del archivo anexo!"
              );
              setMostrarAnexos(true);
            } else {
              setMsg("No se han encontrado archivos anexos!");
            }
          }
        }
      } catch (error) {
        return error.message;
      }
    };

    consultar();
    iniciarVariables();
  }, [props.idProyectoActividad]);

  const mostrarTipoArchivo = (tipo) => {
    if (tipo === 1) return "Video";
    else if (tipo === 2) return "Imagen";
    else if (tipo === 3) return "Documento";
    else if (tipo === 4) return "Audio";
  };

  const verAnexos = (event, tipoArchivo, rutaArchivo) => {
    event.preventDefault();
    iniciarVariables();
    setRuta(RUTA_IMG + props.carpeta + "/" + rutaArchivo);
    if (tipoArchivo === 1) {
      setVerReproductor(true);
    } else if (tipoArchivo === 2) {
      setVerImagen(true);
    } else if (tipoArchivo === 3) {
      setVerDocumento(true);
    } else if (tipoArchivo === 4) {
      setVerAudio(true);
    }
  };

  const iniciarVariables = () => {
    setVerReproductor(false);
    setVerImagen(false);
    setVerDocumento(false);
    setVerAudio(false);
  };

  const salir = () => {
    props.setVerListaAnexos(false);
  };

  return (
    <Modal
      show={props.verListaAnexos}
      onHide={salir}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <img
          src={Logo}
          className="img-fluid"
          width="40px"
          height="120px"
          alt="logo"
        />
        <Modal.Title> {tab} VISUALIZADOR DE ANEXOS</Modal.Title>
      </Modal.Header>
      <form method="post" encType="multipart/form-data">
        <Modal.Body>
          <div className="row mb-3 mt-1">
            <Stack
              spacing={{ xs: 1, sm: 2 }}
              direction="row"
              useFlexGap
              sx={{ flexWrap: "wrap" }}
            >
              <Alert severity="success" className="form-control">
                <strong>{msg}</strong>
              </Alert>
            </Stack>
          </div>

          {verReproductor && (
            <div className="player-wrapper">
              <ReactPlayer
                className="react-player"
                url={ruta}
                width="100%"
                height="100%"
                controls={true}
              />
            </div>
          )}

          {verImagen && (
            <div className="mt-3 mb-3 text-center">
              <img
                src={ruta}
                alt={"Imagen"}
                className="img-fluid card-img-top img-centered"
                style={{ height: 250, width: 250 }}
              />
            </div>
          )}

          {verDocumento && (
            <div className="row">
              <DocumentViewer
                url={ruta}
                viewer={"google"} // 'google' o 'office'
                style={{ width: "100%", height: "500px" }}
              />
            </div>
          )}

          {verAudio && <video src={ruta} id="video_player" controls />}

          <Stack
            spacing={{ xs: 1, sm: 1 }}
            direction="row"
            useFlexGap
            flexWrap="wrap"
          >
            {mostrarAnexos &&
              datos.map((reg, index) => {
                return (
                  <Chip
                    key={index}
                    label={
                      mostrarTipoArchivo(reg.TipoArchivo) + ": " + reg.Ruta
                    }
                    color="primary"
                    variant="outlined"
                    onClick={(event) =>
                      verAnexos(event, reg.TipoArchivo, reg.Ruta)
                    }
                  />
                );
              })}
          </Stack>

          <Modal.Footer>
            <Button variant="secondary" onClick={salir}>
              Salir
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </form>
    </Modal>
  );
}
export default VerAnexosLista;
